var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Lock',{attrs:{"helpless":""},on:{"ready":function($event){return _vm.load()}}},[_c('Overlay',{staticClass:"uk-height-viewport",attrs:{"error":_vm.error,"reason":_vm.reason,"action":_vm.action},on:{"ok":_vm.onOk}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }